import React, { FC } from 'react';
import MuiListItem, { ListItemProps as MuiListItemProps } from '@mui/material/ListItem';
import { BpDesignSystem } from '../../types';

export type ListItemProps = BpDesignSystem.PropsWithChildren<MuiListItemProps & {}>;

export const ListItem: FC<ListItemProps> = ({ dataTest, ...props }) => (
  <MuiListItem data-test={dataTest ?? 'list-item'} {...props} />
);
